import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    reload();
  }, [reload]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* cookies cleared server-side when reachable */ }
    setUser(false);
  };
  const has = (...roles) => !!user && roles.some((r) => user.roles?.includes(r));

  return <AuthCtx.Provider value={{ user, setUser, reload, logout, has }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
